import React from "react";
import { useRef, useState } from "react";
import classes from "./ImagePicker.module.css";
import { Tooltip } from "primereact/tooltip";
import clsx from "clsx";
import { CiImageOn } from "react-icons/ci";
import { Pencil, Trash } from "../../constant";
import { InformationCircle } from "../../constant";

const PreviewImagePicker = ({ 
  label, 
  name, 
  value, 
  onChange, 
  onDelete, 
  errorText, 
  className,
  disabled = false 
}) => {
  const imageInputRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const checkTypeFunction = (e) => {
    if (typeof onChange === "function") {
      onChange(e);
    }
  };
  
  function handleClick() {
    if (disabled || isLoading) return;
    imageInputRef?.current?.click();
  }

  function handleImageChange(event) {
    if (disabled || isLoading) return;
    
    setIsLoading(true);
    const file = event?.target?.files[0];
    
    if (!file) {
      checkTypeFunction(null);
      setIsLoading(false);
      return;
    }
    
    const fileReader = new FileReader();
    fileReader.onload = () => {
      checkTypeFunction(fileReader?.result);
      setIsLoading(false);
    };
    
    fileReader.onerror = () => {
      setIsLoading(false);
    };
    
    fileReader?.readAsDataURL(file);
  }

  function handleDelete() {
    if (disabled || isLoading) return;
    
    if (typeof onDelete === "function") {
      onDelete();
    }
  }

  return (
    <>
      <div className={clsx(classes.picker, className, {
        [classes.disabled]: disabled || isLoading
      })}>
        <Tooltip target=".custom-target-icon" />
        {label && (
          <div className={classes.labelWrapper}>
            <label htmlFor={name} className={classes.label}>
              {label}
            </label>
            <InformationCircle
              className={clsx(classes.infoIcon, "custom-target-icon")}
              size={20}
              color="#a4abb9"
            />
          </div>
        )}
        <div className={classes.controls}>
          <div className={classes.preview}>
            <div className={classes.actionsWrapper}>
              {onDelete && (
                <span
                  onClick={handleDelete}
                  className={clsx({[classes.disabledAction]: disabled || isLoading})}
                >
                  <Trash className={classes.icon} size={20} color="#a4abb9" />
                </span>
              )}
              {value && (
                <span 
                  onClick={handleClick}
                  className={clsx({[classes.disabledAction]: disabled || isLoading})}
                >
                  <Pencil className={classes.icon} size={20} color="#a4abb9" />
                </span>
              )}
            </div>

            <div className={classes.previewImage}>
              {isLoading && <div className={classes.loader}>Loading...</div>}
            </div>
            {value ? (
              <img
                className={clsx(classes.image, "img-fluid")}
                src={value}
                alt="The image selected by user"
                fill
              />
            ) : (
              <button
                onClick={handleClick}
                className={classes.button}
                type="button"
                disabled={disabled || isLoading}
              >
                {isLoading ? "Loading..." : "Upload Image"}
              </button>
            )}
          </div>
          <input
            className={classes.input}
            type="file"
            id={name}
            accept="image/png, image/jpeg, image/jpeg"
            name={name}
            ref={imageInputRef}
            onChange={handleImageChange}
            disabled={disabled || isLoading}
          />
        </div>
      </div>
      {errorText && <p className={"errorText"}>{errorText}</p>}
    </>
  );
};

export default PreviewImagePicker;
